<ng-template #attente>
  <div class="car-progress-bar" style="margin: 20px 0;">
    <div class="car-progress-bar__inner">Chargement des commandes...</div>
  </div>
</ng-template>

<div class="car-page">
  <div class="car-panel grp-decorated-panel">

    <div class="car-panel__header grp-panel-header">
      <div class="car-panel__header-left">
        <svg fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" width="22" height="22"
          class="grp-icon-pulse" style="margin-right: 10px; color: #4f46e5;">
          <path stroke-linecap="round" stroke-linejoin="round"
            d="M19.5 14.25v-2.625a3.375 3.375 0 00-3.375-3.375h-1.5A1.125 1.125 0 0113.5 7.125v-1.5a3.375 3.375 0 00-3.375-3.375H8.25m0 12.75h7.5m-7.5 3H12M10.5 2.25H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 00-9-9z" />
        </svg>
        <span class="grp-title-text">Liste des Documents & Commandes</span>
      </div>
    </div>

    <div class="car-panel__body" style="padding: 24px;">
      <div *ngIf="exist; else attente"></div>

      <div class="grp-filter-strip">
        <div class="car-field grp-input-group">
          <label class="car-label">Du (Date Début)</label>
          <input type="date" class="car-input grp-fancy-input" name="filterStartDate" [(ngModel)]="date_Debut" />
        </div>

        <div class="car-field grp-input-group">
          <label class="car-label">Au (Date Fin)</label>
          <input type="date" class="car-input grp-fancy-input" name="filterEndDate" [(ngModel)]="date_Fin" />
        </div>

        <div class="grp-action-col">
          <button type="button" class="car-btn car-btn--primary grp-fancy-btn" (click)="getListeDocument()">
            <svg fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" width="18" height="18"
              style="margin-right: 8px;">
              <path stroke-linecap="round" stroke-linejoin="round"
                d="M21 21l-5.197-5.197m0 0A7.5 7.5 0 105.196 5.196a7.5 7.5 0 0010.637 10.636z" />
            </svg>
            Filtrer
          </button>
        </div>
      </div>

      <div class="grp-document-split">

        <div class="grp-split-master">
          <div class="grp-section-subhead">
            <h3>Commandes Enregistrées</h3>
          </div>
          <div class="car-table-wrap grp-shadow-wrap">
            <app-liste #listeDocumentComponen [heightTable]="'450'" [dataSourceBrut]=""
              (btnTable)="clickBtnHeat($event)" (outputAction)="outputActionListeHeurSemaineComponent($event)"
              [displayedColumnsBrut]="columns">
            </app-liste>
          </div>
        </div>

        <div class="grp-split-detail" *ngIf="commande && commande.length > 0">

          <div class="grp-client-card">
            <h4 class="grp-section-subhead-text">
              <svg fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" width="18" height="18">
                <path stroke-linecap="round" stroke-linejoin="round"
                  d="M15.75 6a3.75 3.75 0 11-7.5 0 3.75 3.75 0 017.5 0zM4.501 20.118a7.5 7.5 0 0114.998 0A17.933 17.933 0 0112 21.75c-2.676 0-5.216-.584-7.499-1.632z" />
              </svg>
              Fiche Client
            </h4>

            <div class="grp-info-grid">
              <div>
                <p class="grp-info-meta"><span>Entreprise:</span> <strong class="grp-text-dark">{{ lastDoc?.Doc_RS
                    }}</strong></p>
                <p class="grp-info-meta"><span>Tél:</span> {{ lastDoc?.Tiers_code }}</p>
                <p class="grp-info-meta"><span>Adresse:</span> {{ lastDoc?.Doc_Adresse }}</p>
              </div>
              <div>
                <p class="grp-info-meta"><span>Client:</span> <strong class="grp-text-dark">{{ lastDoc?.Doc_Param3
                    }}</strong></p>
                <p class="grp-info-meta"><span>Email:</span> <a href="mailto:{{ lastDoc?.Doc_Param2 }}"
                    class="grp-link">{{ lastDoc?.Doc_Param2 }}</a></p>
                <p class="grp-info-meta"><span>Ville:</span> {{ lastDoc?.Doc_Param4 }}</p>
              </div>
            </div>

            <div *ngIf="lastDoc?.Doc_Obs" class="grp-notes-callout">
              <strong>Notes :</strong> {{ lastDoc?.Doc_Obs }}
            </div>
          </div>

          <div class="grp-order-manifest">
            <div class="grp-manifest-header">
              <h3>
                <svg fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" width="18" height="18"
                  style="color: #0ea5e9;">
                  <path stroke-linecap="round" stroke-linejoin="round"
                    d="M9 12h3.75M9 15h3.75M9 15.75h3.75M18 10.5v7.5c0 .414-.336.75-.75.75h-10.5a.75.75 0 01-.75-.75v-7.5m12 0a.75.75 0 00-.75-.75H4.5a.75.75 0 00-.75.75v7.5c0 .414.336.75.75.75h10.5a.75.75 0 00.75-.75v-7.5z" />
                </svg>
                Bon de Commande : <mark class="grp-badge-blue">{{ commande[0]?.Doc_Num }}</mark>
              </h3>
            </div>

            <div class="car-table-wrap grp-rounded-table">
              <table class="grp-invoice-table">
                <thead>
                  <tr>
                    <th>Code</th>
                    <th>Libellé</th>
                    <th style="text-align: right;">P.U</th>
                    <th style="text-align: center;">Qté</th>
                    <th style="text-align: right;">Total</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let article of commande">
                    <td class="grp-font-medium">{{ article.Art_Code }}</td>
                    <td class="grp-text-muted">{{ article.Art_Des }}</td>
                    <td style="text-align: right; font-variant-numeric: tabular-nums;">{{ article.DocD_PUHTN | number :
                      "1.3-3" }} D</td>
                    <td style="text-align: center; font-variant-numeric: tabular-nums;">
                      <span class="grp-qty-badge">{{ article.DocD_Q }}</span>
                    </td>
                    <td class="grp-text-total">
                      {{ article.DocD_PUHTN * article.DocD_Q | number : "1.3-3" }} D
                    </td>
                  </tr>
                </tbody>
                <tfoot>
                  <tr>
                    <td colspan="4" class="grp-invoice-total-label">Montant Global HT</td>
                    <td class="grp-invoice-total-value">{{ getTotal() }}</td>
                  </tr>
                </tfoot>
              </table>
            </div>

            <div class="grp-delivery-status-box"
              *ngIf="generalService.cuurentUser === 'BIGDAR' || generalService.cuurentUser === 'SNCT'">

              <div *ngIf="generalService.cuurentUser === 'BIGDAR'" class="grp-badge-row">
                <span class="grp-delivery-label">
                  <svg fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" width="16" height="16">
                    <path stroke-linecap="round" stroke-linejoin="round"
                      d="M8.25 18.75a1.5 1.5 0 01-3 0m3 0a1.5 1.5 0 00-3 0m3 0h6m-9 0H3.375a1.125 1.125 0 01-1.125-1.125V14.25m17.25 4.5a1.5 1.5 0 01-3 0m3 0a1.5 1.5 0 00-3 0m3 0h1.125c.621 0 1.129-.504 1.09-1.124a17.902 17.902 0 00-3.213-9.193 2.056 2.056 0 00-1.58-.86H14.25M16.5 18.75h-2.25m0-11.177v-.958c0-.568-.422-1.048-.987-1.106a48.554 48.554 0 00-10.026 0 1.106 1.106 0 00-.987 1.106v7.635m12-6.677v6.677m0 4.5v-4.5m0 0h-12" />
                  </svg>
                  Frais de livraison :
                </span>
                <span class="grp-delivery-price">{{ fraisLivraisonBigDar() | number : "1.3-3" }} DT</span>
              </div>

              <div *ngIf="generalService.cuurentUser === 'SNCT'">
                <div class="grp-badge-row" *ngIf="lastDoc?.Doc_Param1" style="margin-bottom: 8px;">
                  <span class="grp-status-pill" [class.grp-status-pill--home]="lastDoc.Doc_Param1 === '1'">
                    <span class="pulse-dot"></span>
                    {{ lastDoc.Doc_Param1 === '1' ? "Livraison à Domicile" : "Retrait en Magasin" }}
                  </span>
                </div>

                <div class="grp-badge-row" *ngIf="lastDoc?.Doc_Param1 === '1'">
                  <span class="grp-delivery-label">Frais logistique :</span>
                  <span class="grp-delivery-price" *ngIf="!hasZeroValue() && !transportZero()">
                    {{ fraisLiv(this.poid) !== 'Sur demande' ? fraisLiv(this.poid) + '.000' : fraisLiv(this.poid) }}
                  </span>
                  <span class="grp-delivery-price grp-delivery-price--quote" *ngIf="hasZeroValue() || transportZero()">
                    Sur demande
                  </span>
                </div>
              </div>

            </div>
          </div>

        </div>
      </div>
    </div>
  </div>
</div>